import React from 'react';

import {
  StateMachineProvider,
  useStateMachineContext
} from '@common/context/StateMachineContext';

import './ContactUs.scss';

import STATES_CONFIG from './statesConfig';

import InitView from './InitView';
import ContactCategories from './ContactCategories';
import ContactSections from './ContactSections';
import ContactForm from './ContactForm';
import Success from './Success';

const ViewManager = () => {
  const { state } = useStateMachineContext();
  switch (state) {
    case 'init':
    default:
      return <InitView />;
    case 'show_categories':
      return <ContactCategories />;
    case 'show_sections':
      return <ContactSections />;
    case 'show_form':
      return <ContactForm />;
    case 'show_success':
      return <Success />;
  }
};

const ContactUs = () => {
  return (
    <StateMachineProvider
      states={STATES_CONFIG}
      initialState={{ state: 'init' }}
    >
      <div className="contact-us-form">
        <ViewManager />
      </div>
    </StateMachineProvider>
  );
};

export default ContactUs;
